import $ from 'jquery';

class ProductUomSelector {
    constructor(containerSelector, options = {}) {
        // --- 1. Khởi tạo thuộc tính ---
        this.container = $(containerSelector);
        if (!this.container.length) return; // Không làm gì nếu không tìm thấy container

        // Lấy các element cần tương tác
        this.tabItems = this.container.find('.product-uoms-tab-item');
        this.tabPanes = this.container.find('.product-uoms-tab-pane');

        // Cấu hình options
        this.options = {
            activeClass: 'active',
            ...options
        };

        // State: lưu UOM đang được chọn
        this.selectedUomId = null;
    }

    // --- 2. Phương thức khởi chạy ---
    init() {
        if (!this.container.length) return;
        this.bindEvents();
        this.initializeDefaultSelection();
    }

    // --- 3. Gán các sự kiện ---
    bindEvents() {
        // Xử lý click vào tab item
        this.tabItems.on('click', (e) => {
            this.handleTabClick(e);
        });
    }

    // --- 4. Logic xử lý chính ---
    handleTabClick(e) {
        const clickedTab = $(e.currentTarget);
        const uomId = clickedTab.data('uom-id');

        // Kiểm tra xem tab này đã được chọn chưa
        if (clickedTab.hasClass(this.options.activeClass)) {
            return; // Không làm gì nếu đã active
        }

        // Chọn UOM mới
        this.selectUom(uomId);
    }

    selectUom(uomId) {
        // Cập nhật state
        this.selectedUomId = uomId;

        // Cập nhật UI cho tab items
        this.tabItems.removeClass(this.options.activeClass);
        this.tabItems.filter(`[data-uom-id="${uomId}"]`).addClass(this.options.activeClass);

        // Cập nhật UI cho tab panes
        this.tabPanes.removeClass(this.options.activeClass).hide();
        this.tabPanes.filter(`[data-uom-id="${uomId}"]`).addClass(this.options.activeClass).show();

        // Emit event để các module khác có thể lắng nghe
        this.container.trigger('uom:changed', {
            uomId: uomId,
            previousUomId: this.selectedUomId
        });
    }

    // --- 5. Khởi tạo mặc định ---
    initializeDefaultSelection() {
        // Tìm tab item đầu tiên hoặc tab item có class active
        let defaultTab = this.tabItems.filter(`.${this.options.activeClass}`).first();

        if (!defaultTab.length) {
            defaultTab = this.tabItems.first();
        }

        if (defaultTab.length) {
            const defaultUomId = defaultTab.data('uom-id');
            this.selectUom(defaultUomId);
        }
    }

    // --- 6. Public methods ---
    getSelectedUomId() {
        return this.selectedUomId;
    }

    setSelectedUomId(uomId) {
        if (this.tabItems.filter(`[data-uom-id="${uomId}"]`).length) {
            this.selectUom(uomId);
        } else {
            console.warn(`UOM with ID ${uomId} not found`);
        }
    }

    // --- 7. Utility methods ---
    showUom(uomId) {
        this.setSelectedUomId(uomId);
    }

    hideAllPanes() {
        this.tabPanes.removeClass(this.options.activeClass).hide();
        this.tabItems.removeClass(this.options.activeClass);
    }
}

export default ProductUomSelector;